module.exports = __webpack_public_path__ + "img/118.f5f58473.jpg";